import React from 'react';
import { IWeather } from '@move-frontend/dap';
import { DateRow } from './DateRow';
import { StatusRow } from './StatusRow';
import { DetailsRow } from './DetailsRow';
import { AdditionalInfoRow } from './AdditionalInfoRow';
import { IEnrichedFlight } from '../../../shared/flight/domain/models/IEnrichedFlight';

interface IProps {
	flight: IEnrichedFlight;
	weather?: IWeather;
}

export const FlightInfo = ({ flight, weather }: IProps) => (
	<>
		<DateRow bestKnownTimestamp={flight.bestKnownTimestamp} />

		<StatusRow
			arrival={flight.arrival}
			iata={flight.viaAirport}
			status={flight.publicStatus}
			airport={flight.viaAirportDetails}
		/>

		<DetailsRow
			airline={flight.airlineDetails}
			icaoOperatingAirline={flight.icaoOperatingAirline}
			codeShareFlightNumber={flight.codeShareFlightNumber}
			bestKnownTimestamp={flight.bestKnownTimestamp}
			scheduledTimestamp={flight.scheduledTimestamp}
			gate={flight.gate}
			arrival={flight.arrival}
			isDelayed={flight.isDelayed}
			status={flight.publicStatus}
			baggageBelt={flight.baggageBelt}
		/>

		<AdditionalInfoRow
			airport={flight.arrivalAirportDetails}
			weather={weather}
			arrival={flight.arrival}
		/>
	</>
);
